/**
 * @prettier
 */

import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

import RedirectButton from "./RedirectButton";

function RedirectSection({ returnUrl, isMobileHandoffSubmission }) {
    const { t } = useTranslation();
    const redirectUrl =
        typeof returnUrl === "string" && returnUrl !== "" ? returnUrl : null;
    const showRedirectButton = redirectUrl && !isMobileHandoffSubmission;
    const showHandoffReturnMessage = redirectUrl && isMobileHandoffSubmission;

    if (!showRedirectButton && !showHandoffReturnMessage) {
        return null;
    }

    return (
        <>
            {showRedirectButton && <RedirectButton redirectUrl={redirectUrl} />}
            {showHandoffReturnMessage && (
                <p className="secondary-text secondary-text-strong">
                    {t("idpal_return_to_desktop")}
                </p>
            )}
        </>
    );
}

function mapStateToProps(state) {
    return {
        isMobileHandoffSubmission:
            state.submissionState.isMobileHandoffSubmission,
        returnUrl: state.config.returnUrl,
    };
}

export default connect(mapStateToProps)(RedirectSection);

